import ComponentAttributesPanel from './ComponentAttributesPanel';
import './ComponentAttributesPanel.scss';
import getComponentAttributesPanelSchema from './componentAttributesSchema';

export { ComponentAttributesPanel, getComponentAttributesPanelSchema };
